/* The queue's Board view (designs/intake-groom.md IG11): the efforts the
   queue shows, in lanes — Not groomed first (IG10), then groomed efforts by
   status — each card naming in red what it still lacks (IG9). A card opens
   the queue's own drawer, where an Admin grooms with Groom… (IG8). Reads
   are open to everyone; the How to groom checklist shows to Admins, whose
   job grooming is (intake-queue-help.md QH8). */
import type { JSX } from "react";
import { BOARD_LANES, GROOM_HELP, boardLanes, groomGaps, type BoardView } from "./board-view";

export function BoardLanes({
  rows,
  isAdmin,
  openId,
  onOpen,
}: {
  rows: BoardView[];
  isAdmin: boolean;
  openId: string | null;
  onOpen: (id: string) => void;
}): JSX.Element {
  const lanes = boardLanes(rows);
  return (
    <div data-board-view>
      {isAdmin && (
        <details className="concept" data-groom-howto>
          <summary>
            <span className="concept-i">ⓘ</span> How to groom
          </summary>
          <div className="concept-body">
            <p>{GROOM_HELP.intro}</p>
            <ol>
              {GROOM_HELP.steps.map((s) => (
                <li key={s}>{s}</li>
              ))}
            </ol>
            <p>{GROOM_HELP.saveNote}</p>
          </div>
        </details>
      )}
      <div className="groom-lanes">
        {BOARD_LANES.map((lane, li) => {
          const cards = lanes[li]!;
          return (
            <div key={lane.label} className="groom-lane" data-groom-lane={lane.label}>
              <div className="groom-lane-head" title={GROOM_HELP.lanes[lane.label]}>
                {lane.label} <span>{cards.length}</span>
              </div>
              {cards.map((r) => {
                const gaps = groomGaps(r);
                return (
                  <button
                    key={r.id}
                    data-row-id={r.id}
                    className={`groom-card${r.id === openId ? " card-open" : ""}`}
                    aria-current={r.id === openId ? "true" : undefined}
                    onClick={() => onOpen(r.id)}
                  >
                    <b>{r.name}</b>
                    <span>
                      {r.teamName} · score {r.score}
                    </span>
                    {/* IG9: closed efforts are done with — their gaps are not asked for */}
                    {lane.label !== "Closed" && gaps.length > 0 && (
                      <span className="gap-chips">
                        {gaps.map((g) => (
                          <span key={g} className="gap-chip">
                            {g}
                          </span>
                        ))}
                      </span>
                    )}
                  </button>
                );
              })}
            </div>
          );
        })}
      </div>
    </div>
  );
}
